import { u as o } from "../styled-components.browser.esm-BFmoFexH.js";
import { Row as e, Col as l } from "antd";
const i = o(e)`
    user-select: none;
    &&& {
        z-index: 1500;
    }
`, n = o(e)`
    ${(t) => t.$isdefault ? `
  font-style: italic;
  color: var(--light-grey);
  
  * {
    color: var(--light-grey);
  }
  ` : ""}
`, c = o(i)`
    ${(t) => t.$isdefault ? `
  font-style: italic;
  color: var(--light-grey);
  
  .ant-select-selection-item{
    color: var(--light-grey);
  }
  ` : ""}
`, s = o(l)`
    padding-left: ${({ $value: t }) => t}px;
`, f = o(l)`
    margin-left: ${({ $value: t }) => t}px;
`;
export {
  f as ColWithLeftMargin,
  s as ColWithLeftPadding,
  n as RowWithDefaultValue,
  i as SortableRow,
  c as SortableRowWithDefaultValue
};
//# sourceMappingURL=utils.js.map
